export default __webpack_public_path__ + "static/media/xpm.bfa051f3.svg";